import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SinglePage from './singlePage';
import { openModal } from '../../actions/modalActions';
import { aggregateFilters } from '../../actions/selectedFilter/inResultsActions';
import {
    clearAllFilters,
    intitalizeFilterQueue
} from '../../actions/selectedFilter/inAssessmentActions';

const mapStateToProps = (state, ownProps) => {
    return {
        assessment: state.app.assessment,
        prompts: state.entities.prompts,
        countryInfo: state.app.countryInfo
    };
};

const mapDispatchToProps = dispatch => {
    return {
        aggregateFilters: () => dispatch(aggregateFilters()),
        clearAllFilters: () => dispatch(clearAllFilters()),
        openModal: modal => dispatch(openModal(modal)),
        initializeFilterQueue: () => dispatch(intitalizeFilterQueue())
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SinglePage));
